// waiting-view.ts — the MP "WAITING FOR ALL PLAYERS…" sim-start overlay (HTML/DOM UI shell
// plan, Phase 5). Renders the canvas WaitForm / kidfWaiting (1062), shown on the SHARED MP
// sim-start path (gamesession.ts) until the server's first block arrives, when the host
// unmounts it.
//
// The canvas WaitForm (multiplayer.ts:55-116 / SimUI.cpp:59-114) grows its 150×25 form to
// FULL-SCREEN black (FORMBACKCOLOR=kiclrBlack), re-centres the title control, and paints a
// CYAN border (kiclrCyanSideFirst) around where the original centred 150×25 rect was. No
// controls but the title — pure display, no result.
//
// forms.ini.pp kidfWaiting 1062 (FORM 0 0 150 25, FORMBACKCOLOR=kiclrBlack, center topmost):
//   LABEL=kidcTitle (0 9 150 0) "" kifntTitle center   ← runtime "WAITING FOR ALL PLAYERS..."

import { el, formScale, at, formTitle } from '../chrome.ts';

// forms.ini.pp kidfWaiting 1062 (FORM 0 0 150 25), in design units.
const FORM = { w: 150, h: 25 };
const TITLE = { x: 0, y: 9, w: 150 };
// kiclrCyanSideFirst — palette.json index 32 ("cyan side 0").
const CYAN = 'rgb(104, 252, 252)';

export interface WaitingViewDeps {
  /** the overlay container (created by the host; this view owns its contents). */
  root: HTMLElement;
  /** the runtime title (kidcTitle), e.g. "WAITING FOR ALL PLAYERS...". */
  title: string;
}

export class WaitingView {
  private readonly d: WaitingViewDeps;

  constructor(d: WaitingViewDeps) {
    this.d = d;
    const s = d.root.style;
    // full-window black cover, ABOVE the in-game modal layer (the canvas form is `topmost`)
    // — it blocks the playfield + HUD until the first block. pointer-events:all swallows taps.
    s.position = 'fixed';
    s.inset = '0';
    s.zIndex = '25';
    s.background = '#000'; // FORMBACKCOLOR kiclrBlack, grown full-screen
    s.color = '#fff';
    s.userSelect = 'none';
    s.pointerEvents = 'all';
    s.overflow = 'hidden';
    window.addEventListener('resize', this.onResize);
    this.render();
  }

  private readonly onResize = (): void => {
    this.render();
  };

  destroy(): void {
    window.removeEventListener('resize', this.onResize);
  }

  render(): void {
    const s = formScale();
    const boxW = FORM.w * s,
      boxH = FORM.h * s;
    // the centred 150×25 region with the CYAN border the canvas paints around the original
    // rect (DrawBorder over m_rcOrig); the rest of the screen is the black root.
    const box = el('div', {
      position: 'absolute',
      width: `${boxW}px`,
      height: `${boxH}px`,
      left: `${Math.round((window.innerWidth - boxW) / 2)}px`,
      top: `${Math.round((window.innerHeight - boxH) / 2)}px`,
      border: `${Math.max(1, Math.round(s))}px solid ${CYAN}`,
      boxSizing: 'border-box',
    });
    box.dataset.waitingBox = '1';
    // kidcTitle (0,9,150,0) center kifntTitle — white on black.
    box.append(at(formTitle(this.d.title, s, { color: '#fff' }), s, TITLE.x, TITLE.y, TITLE.w));
    this.d.root.replaceChildren(box);
  }
}
